import type { Lead, GetLeadsRequest } from '@/apis/generated/dialbunny';
import { LeadFromJSON } from '@/apis/generated/dialbunny';
import { apiStoreFactory } from '../api-store-factory';
import type { StoreEntity } from '../api-store-factory';
import { STORE } from '@/store-ids';

export type LeadListItemStore = StoreEntity<Lead, 'id', GetLeadsRequest>;

export const useLeadStore = apiStoreFactory<
  LeadListItemStore['entity'],
  LeadListItemStore['id'],
  LeadListItemStore['filter'],
  LeadListItemStore['createInput'],
  LeadListItemStore['updateInput']
>(
  STORE.LEAD,
  { entityIdKey: 'id' },
  {
    readAll: async (filter, { dialbunnyApi }, signal) => {
      return await dialbunnyApi.getLeadsRaw(filter, { signal });
    },
    read: async (leadId: string, { dialbunnyApi }) => {
      return await dialbunnyApi.getLead({ leadId });
    },
    bulkRead: async (leadIds: string[], { dialbunnyApi }) => {
      const items = await dialbunnyApi.getModelsByKeysOfKind({
        kind: 'Lead',
        ids: leadIds.join(','),
      });

      return items.map(LeadFromJSON);
    },
  },
);
